import { render, staticRenderFns } from "./tzgzb.vue?vue&type=template&id=040f3dd0&scoped=true&"
import script from "./tzgzb.vue?vue&type=script&lang=js&"
export * from "./tzgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f3dd0",
  null
  
)

export default component.exports